import { getRequest } from "../services"
import { sendNotification } from "../redux/notificationsSlice"

const MANAGEMENT_CACHE_TTL_MS = 60_000
let managementUsersCache = null
let managementUsersCacheTime = 0

const fetchManagementUsers = async () => {
  const now = Date.now()
  if (managementUsersCache && now - managementUsersCacheTime < MANAGEMENT_CACHE_TTL_MS) {
    return managementUsersCache
  }

  const response = await getRequest("/api/Management")
  managementUsersCache = Array.isArray(response.data) ? response.data : []
  managementUsersCacheTime = now
  return managementUsersCache
}

const resolveUserIdByEmail = async (email) => {
  if (!email) return null

  const users = await fetchManagementUsers()
  const normalized = email.trim().toLowerCase()
  const match = users.find(
    (user) => (user.email || "").trim().toLowerCase() === normalized
  )

  return match?.id || match?.userId || null
}

export const notifyAdminFormAction = (
  dispatch,
  admin,
  title,
  message,
  linkPath = "/account-settings"
) => {
  const adminUserId = admin?.id || admin?.userId
  if (!adminUserId) return

  const url = `${window.location.origin}${linkPath}`
  dispatch(
    sendNotification({
      UserIds: [adminUserId],
      Title: title,
      Body: `${message} <a href="${url}" target="_blank">Open Account Settings</a>`,
    })
  )
}

export const notifySuperAdminFormSubmission = async (
  dispatch,
  { initiatedByEmail, adminName, title, message, linkPath = "/management" }
) => {
  try {
    const superAdminUserId = await resolveUserIdByEmail(initiatedByEmail)
    if (!superAdminUserId) return

    const url = `${window.location.origin}${linkPath}`
    const byAdmin = adminName ? ` by ${adminName}` : ""
    const linkLabel = linkPath === "/management" ? "Open Management" : "Open"

    dispatch(
      sendNotification({
        UserIds: [superAdminUserId],
        Title: title,
        Body: `${message}${byAdmin}. <a href="${url}" target="_blank">${linkLabel}</a>`,
      })
    )
  } catch {
    // Notification failure should not block form submission
  }
}
